module.exports = __webpack_public_path__ + "img/5.facefd48.png";